"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _hooks = require("../../utils/hooks");

var _HeroVariants = require("./HeroVariants");

var _calculateVideoSettings = require("./calculateVideoSettings");

var _AddToCalendar = require("../AddToCalendar");
/*
 * N.B. IE 11 will need an IntersectionObserver pollyfill for gatsby-background-image. See https://www.gatsbyjs.org/packages/gatsby-background-image/
 */


var Hero = function Hero(_ref) {
  var banner = _ref.banner,
      cta = _ref.cta,
      fluid = _ref.fluid,
      headlineImage = _ref.headlineImage,
      src = _ref.src,
      subTitle = _ref.subTitle,
      textColor = _ref.textColor,
      title = _ref.title,
      variant = _ref.variant,
      video = _ref.video;

  var _ref2 = (0, _emotionTheming.useTheme)(),
      hero = _ref2.hero,
      breakpoints = _ref2.breakpoints;

  var windowWidth = (0, _hooks.useWindowWidth)();
  var isTextOnly = title && !cta && !subTitle;
  var wrapperProps = {};

  if (fluid || src) {
    wrapperProps = {
      fluid: fluid,
      src: src,
      mediaType: 'backgroundImage'
    };
  } else if (video) {
    wrapperProps = _objectSpread(_objectSpread(_objectSpread({}, video), (0, _calculateVideoSettings.calcVidSettings)(video, breakpoints, windowWidth, variant)), {}, {
      mediaType: 'video',
      playsinline: true
    });
  }

  var heroProps = {
    banner: banner,
    cta: cta,
    headlineImage: headlineImage,
    hero: hero,
    subTitle: subTitle,
    textColor: textColor,
    title: title,
    variant: variant,
    video: video,
    wrapperProps: wrapperProps
  };

  if (variant === 'article') {
    return /*#__PURE__*/_react.default.createElement(_HeroVariants.HeroArticle, heroProps);
  }

  if (headlineImage) {
    return /*#__PURE__*/_react.default.createElement(_HeroVariants.HeroHeadlineImage, heroProps);
  }

  if (isTextOnly) {
    return /*#__PURE__*/_react.default.createElement(_HeroVariants.HeroTextOnly, heroProps);
  }

  return /*#__PURE__*/_react.default.createElement(_HeroVariants.HeroRegular, heroProps);
};

Hero.propTypes = {
  /** Hero variant */
  variant: _propTypes.default.oneOf(['standard', 'large', 'article']),

  /** Text color for title and subtitle */
  textColor: _propTypes.default.oneOf(['standard', 'inverted']),

  /** Hero title */
  title: _propTypes.default.string,

  /** Hero body copy */
  subTitle: _propTypes.default.string,

  /** Hero call to action  */
  cta: _propTypes.default.shape({
    /** Hero call to action label */
    label: _propTypes.default.string,

    /** Hero call to action URL */
    url: _propTypes.default.string,

    /** Calendar event for the AddToCalendar CTA component */
    calendarEvent: _propTypes.default.shape(_AddToCalendar.addToCalendarPropTypes)
  }),

  /** Fluid image object */
  fluid: _propTypes.default.shape({
    base64: _propTypes.default.string.isRequired,
    aspectRatio: _propTypes.default.number.isRequired,
    src: _propTypes.default.string.isRequired,
    srcSet: _propTypes.default.string.isRequired,
    srcSetWebp: _propTypes.default.string.isRequired,
    sizes: _propTypes.default.string.isRequired
  }),

  /** File src of image object in case we dont have a fluid obj */
  src: _propTypes.default.string,

  /** Video object, refer to the component for all available options */
  video: _propTypes.default.shape({
    url: _propTypes.default.string,
    zoom: _propTypes.default.string
  }),
  banner: _propTypes.default.shape({
    image: _propTypes.default.shape({
      src: _propTypes.default.string,
      fluid: _propTypes.default.shape({}),
      fixed: _propTypes.default.shape({})
    }),
    label: _propTypes.default.string
  }),
  headlineImage: _propTypes.default.shape({
    src: _propTypes.default.string,
    fluid: _propTypes.default.shape({}),
    fixed: _propTypes.default.shape({})
  })
};
Hero.defaultProps = {
  banner: null,
  cta: null,
  fluid: null,
  headlineImage: null,
  src: null,
  subTitle: null,
  textColor: 'standard',
  title: null,
  variant: 'standard',
  video: null
};
var _default = Hero;
exports.default = _default;